import { render, staticRenderFns } from "./SharedEmailAddressOptionsDialog.vue?vue&type=template&id=4cb4dea8&scoped=true&"
import script from "./SharedEmailAddressOptionsDialog.vue?vue&type=script&lang=ts&"
export * from "./SharedEmailAddressOptionsDialog.vue?vue&type=script&lang=ts&"
import style0 from "./SharedEmailAddressOptionsDialog.vue?vue&type=style&index=0&id=4cb4dea8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb4dea8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VDialog,VProgressCircular,VSpacer})
